{
  "page_count": "von {n, plural, one{# Seite} other{# Seiten}}"
}
